import React from 'react'
import axios from 'axios'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { media } from 'src/styles/styled-components'

// ArComponents
import ArBaseIcon from 'src/components/ArBaseIcon/ArBaseIcon'
import ArSectionHeading from 'src/components/typography/ArSectionHeading'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArSectionDescription from 'src/components/typography/ArSectionDescription'

const $vertGap = ['20px', '40px', '50px'] // [mobile, tablet, desktop]
const $hoverDur = 200

const StyledWrapper = styled.section`
  background-color: ${ p => p.theme.colors.mineShaft };
  color: ${ p => p.theme.colors.white };
  padding-bottom: 30px;
  padding-top: 30px;

  ${ media.tablet`
    padding-top: 60px;
    padding-bottom: 60px;
  ` }

  ${ media.desktop`
    padding-top: 100px;
    padding-bottom: 100px;
  ` }
`

const StyledContainer = styled(ArBaseContainer)`
  margin-bottom: ${ '-' + $vertGap[0] };

  ${ media.tablet`
    margin-bottom: ${ '-' + $vertGap[1] };
  ` }

  ${ media.tablet`
    margin-bottom: ${ '-' + $vertGap[2] };
  ` }
`

const StyledTitle = styled(ArSectionHeading)`

`

const StyledDescription = styled(ArSectionDescription)`

`

const StyledList = styled.ul`
  margin-top: 30px;

  ${ media.tablet`
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  ` }

  ${ media.desktop`
    margin-top: 66px;
  ` }
`

const StyledItem = styled.li`
  background-color: ${ p => p.theme.colors.white };
  border-radius: 4px;
  color: ${ p => p.theme.colors.black };
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: ${ $vertGap[0] };
  min-height: 93px;
  padding: 15px 52px 15px 25px;
  position: relative;
  transition: background-color ${ $hoverDur + 'ms' };

  ${ media.tablet`
    margin-bottom: ${ $vertGap[1] };
    width: 47.24%;
  ` }

  ${ media.desktop`
    margin-bottom: ${ $vertGap[2] };
    width: ${ p => p.scEven ? '47.9%' : '30.65%' };
  ` }

  &:hover {
    background-color: ${ p => p.theme.colors.purple };
    * {
      color: ${ p => p.theme.colors.white } !important;
      opacity: 1;
    }
  }
`

const StyledItemTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: ${ p => p.theme.fontWeight.primary.Bold };
  margin-bottom: 10px;
  margin-right: 10px;
  transition: color ${ $hoverDur + 'ms' };

  ${ media.desktop`
    font-weight: ${ p => p.theme.fontWeight.primary.Light };
    margin-bottom: 12px;
    font-size: 2.8rem;
  ` }
`

const StyledItemLabel = styled.p`
  font-family: ${ ({ theme }) => theme.font.secondary };
  font-size: 1.4rem;
  font-weight: ${ p => p.theme.fontWeight.secondary.Bold };
  letter-spacing: 0.01em;
  opacity: 0.5;
  transition: color ${ $hoverDur + 'ms' };

  ${ media.desktop`
    color: ${ p => p.theme.colors.purple };
    opacity: 1;
    font-weight: ${ p => p.theme.fontWeight.secondary.Regular };
  ` }
`

const StyledIcon = styled(ArBaseIcon)`
  position: absolute;
  top: 50%;
  right: 25px;
  transform: translateY(-50%);
  transition: color ${ $hoverDur + 'ms' };
`

class ArJobsListing extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    jobs: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      label: PropTypes.string,
    })),
  }

  state = {
    loading: true,
    jobs: [],
  }

  componentWillMount () {
    this.fetchJobs()
  }

  fetchJobs () {
    this.setState({ loading: true })
    axios
      .get(process.env.JOBS_DATA_URL)
      .then(({ data }) => {
        const { jobs } = data
        this.setState({
          loading: false,
          jobs,
        })
      })
  }

  render () {
    const { title, description, ...rest } = this.props
    return (
      <StyledWrapper {...rest}>
        <StyledContainer>
          <StyledTitle>{ title }</StyledTitle>
          <StyledDescription>{ description }</StyledDescription>
          <StyledList>
            {this.state.jobs.map(({ title, department, location, url }, index) =>
              <StyledItem key={index} scEven={!(this.state.jobs.length % 2)}>
                <a href={url} target='_blank' rel="noopener">
                  <StyledItemTitle>{ title }</StyledItemTitle>
                  <StyledItemLabel>{ department } ({location.city})</StyledItemLabel>
                  <StyledIcon size={17} name={'tailed-arrow-right'}></StyledIcon>
                </a>
              </StyledItem>
            )}
          </StyledList>
        </StyledContainer>
      </StyledWrapper>
    )
  }
}

export default ArJobsListing
